import wrapWithProviders from './theme-wrapper';

export const wrapRootElement = wrapWithProviders;